'use client';

import { FC } from 'react';

import { ServerSideErrorPage } from '@telialt/core-nextjs/src/components/Error/ServerSideErrorPage';
import { QueryProvider } from '@telialt/core-nextjs/src/components/Providers/QueryProvider';
import { StyledComponentsProvider } from '@telialt/core-nextjs/src/components/Providers/StyledComponentsProvider';
import { useLogErrorPublicWeb } from '@telialt/utils/src/datadog/useLogError';

type Props = {
    error: Error;
};

const GlobalError: FC<Props> = ({ error }) => {
    useLogErrorPublicWeb(error);

    return (
        <html lang="lt">
            <body>
                <QueryProvider>
                    <StyledComponentsProvider>
                        <ServerSideErrorPage />
                    </StyledComponentsProvider>
                </QueryProvider>
            </body>
        </html>
    );
};

export default GlobalError;
